<template>
	<div>
		<div class="tableView">
			<div class="table_list">
				<span style="line-height: 32px">名称:</span>
				<el-input v-model="select.selectName" placeholder="请输入项目名称" @clear="getApplication" :clearable="true"
					style="margin-left: 10px;width: 200px;"></el-input>
			</div>
			
			<!--<div class="table_list">
				<span style="line-height: 32px;margin-left: 20px;">项目类型:</span>
				<el-select v-model="select.selectValue1" @clear="getApplication" clearable placeholder="请选择"
					style="width:auto;margin-left: 10px;" @change="selectChange1">
					<el-option v-for="(item, index) in select.options1" :key="index" :label="item.text" :value="index">
					</el-option>
				</el-select>
			</div>-->
			<div class="table_list">
				<span style="line-height: 32px;margin-left: 20px;">状态:</span>
				<el-select v-model="select.selectValue2" @clear="getApplication" clearable placeholder="请选择"
					style="width:auto;margin-left: 10px;" @change="selectChange2">
					<el-option v-for="(item, index) in select.options2" :key="index" :label="item.text" :value="index">
					</el-option>
				</el-select>
			</div>
			<div>
				<el-button type="primary" style="margin-left: 20px" @click="searchData">
					查询
				</el-button>
			</div>
		</div>
		<!-- 表格 -->
		<normalTable v-loading="loading" :tabList="tabList" :tableList="tableList" @copol-click="reciveClick">
		</normalTable>

		<div style="margin-top: 50px;" v-if="totalNum>10">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalNum" background>
			</el-pagination>
		</div>

		<!-- 弹窗 -->
		<payMoney ref="paymoney"></payMoney>

	</div>
</template>

<script>
	import {
		getAppliInfo,
		getProjectType
	} from '../../api/moudles/application.js'

	import payMoney from './components/payMoney.vue'
	import normalTable from '../../components/table/normalTable.vue'
	export default {
		data() {
			return {
				select: {
					options1: [],
					options2: [],
					selectName: '',
					selectValue1: '',
					selectValue2: ''
				},
				tabList: [ '项目名称', '申请时间', '审核时间', '名额', '已申报', '状态', '动作'],
				tableList: [],
				tabCodeList: [],
				loading: false,
				// 分页
				currentPage: 1,
				pageSize: 10,
				totalNum: 0
			}
		},
		components: {
			payMoney,
			normalTable
		},
		created() {
			this.level()
			this.getApplication()
			this.getProjecttype()
		},
		methods: {
			// 获取下拉选项
			async getProjecttype() {
				await getProjectType({
					data: {},
					success: res => {
						console.log(res)
						const typeAll = res.data.typeAll
						const statusAll = res.data.statusAll
						const newtypeAll = []
						const newStatusAll = []
						
						Object.keys(typeAll).forEach((item, index) => {
							const newList = {}
							newList.text = typeAll[item]
							newtypeAll.push(newList)
						})
						statusAll.forEach((item, index) => {
							const newList = {}
							newList.text = item
							newStatusAll.push(newList)
						})
						this.select.options1 = newtypeAll
						this.select.options2 = newStatusAll
					}
				})
			},
			selectChange1() {
				// console.log(this.select.selectValue1)
			},
			selectChange2() {
				// console.log(this.select.selectValue2)
			},
			searchData() {
				this.getApplication()
			},
			// 分页
			handleSizeChange(val) {
				this.pageSize = val
				this.getApplication()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getApplication()
			},
			// 二级管理员跳转
			level() {
				const level = localStorage.getItem('userLevel')
				if (level === '2') {
					// console.log('2', level)
					this.$router.replace('/infochange')
				}
			},
			async getApplication() {
				const params = {
					name: this.select.selectName,
					project_type: this.select.selectValue1,
					status: this.select.selectValue2,
					page: this.currentPage,
					limit: this.pageSize
				}
				this.loading = true
				await getAppliInfo({
					data: params,
					success: (res) => {
						// console.log('获取信息', res)
						this.totalNum = res.totalCount
						let dataList = res.data;
						let upCode = []
						let upList = []
						dataList.forEach((item) => {
							let newlist = {}
							//newlist['project_type_name'] = item.project_type_name
							newlist['project_name'] = item.project_name
							newlist['apply_time'] = item.apply_time
							newlist['app_time'] = item.app_time
							newlist['distribution_count'] = item.enp.distribution_count
							newlist['collect_count'] = item.enp.collect_count
							newlist['status_name'] = item.enp.status_name
							newlist['soqcol'] = ['二级管理员']
							upCode.push(item.enp.project_code)
							upList.push(newlist)
						})
						this.tabCodeList = upCode
						this.tableList = upList
						this.loading = false
					}
				})
			},
			// 弹窗
			payMoney() {
				this.$refs['paymoney'].showPay()
			},
			showCopol(key) {
				// console.log('key', key)
				this.payMoney()
			},
			// 接受子组件事件
			reciveClick(e) {
				const {
					key
				} = e
				this.$refs['paymoney'].showPay(this.tabCodeList[key])
			}
		}
	}
</script>

<style scoped="scoped">
	.tableView {
		display: flex;
		margin: 20px 0;
		flex-wrap: wrap;
	}
	.table_list{
		margin-bottom: 10px;
	}
</style>
